import axios from 'axios'

const DEFAULT_TIMEOUT = 10000
const configuredTimeout = Number(process.env.VUE_APP_API_TIMEOUT)

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: Number.isFinite(configuredTimeout) ? configuredTimeout : DEFAULT_TIMEOUT,
  headers: {
    'Content-Type': 'application/json'
  }
})

request.interceptors.request.use(
  (config) => {
    const token = window.localStorage.getItem('token')

    if (token) {
      config.headers = config.headers || {}
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error) => Promise.reject(error)
)

request.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const responseData = error.response && error.response.data
    const message = responseData && responseData.message

    if (message) {
      error.message = message
    }

    return Promise.reject(error)
  }
)

export const http = {
  get(url, params, config = {}) {
    return request.get(url, { ...config, params })
  },
  post(url, data, config = {}) {
    return request.post(url, data, config)
  },
  put(url, data, config = {}) {
    return request.put(url, data, config)
  },
  patch(url, data, config = {}) {
    return request.patch(url, data, config)
  },
  delete(url, config = {}) {
    return request.delete(url, config)
  }
}

export default request
